{
  "validEmailsTitle": "E-mails/Domaines valides",
  "newEmailPlaceholder": "Nouvel e-mail/domaine",
  "addButton": "Ajouter",
  "emailToTestPlaceholder": "E-mail de test",
  "testButton": "Test",
  "testPassed": "Validé. Cet e-mail sera autorisé à accéder.",
  "testFailed": "Échec. Cet e-mail ne sera pas autorisé à accéder.",
  "passwordWhitelistTitle": "Liste blanche d'authentification par mot de passe",
  "newEmailWhitelistPlaceholder": "Nouvel e-mail",
  "defaultReason": "Ajouté via admin",
  "whitelistTestPassed": "Validé. Cet e-mail peut utiliser l'authentification par mot de passe.",
  "whitelistTestFailed": "Échec. Cette adresse e-mail doit utiliser la connexion Microsoft ou Google."
}
